import 'jquery.marquee'
import Rellax from 'rellax'
import scrollMonitor from 'scrollmonitor'

/**
 * Hero photo fade in 
 **/
 const heroFadeIn = () => {
  setTimeout(() => {
    $('.hero-image').addClass('fadeinbuttom')
  }, 1000)
 }

 /**
 * Fade in text for Gutenberg blocks.
 */
const fadeInText = () => {
  const fadeInEvent = ($el) => {
    let el = $el[0], 
      watcher = scrollMonitor.create(el, -500)

    watcher.one('enterViewport', ()=> {
      $el.find('.faded').addClass('in-view')
    })
  }

  $('.block\\(imagesAndText\\), .block\\(gallery\\)').each(function () {
    fadeInEvent($(this))
  })
}

/** 
 * Add parallax functionality to decorations
 * @param {string} selector
 */
const initRellax = (selector) => {
  let decoration = document.querySelector(selector)
  if (decoration) {
    new Rellax(selector)
  }
}

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    heroFadeIn()
    fadeInText()
    initRellax('.parallax')
    $('.marquee').each(function(){
      $(this).marquee({
        'startVisible' : true,
        'allowCss3Support' : true,
        'speed' : 10,
        'gap' : 20,
        'pauseOnHover' : true,
      })
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js